import store from '../../../store';
import {TYPES_NEEDING_OPTIONS} from '../options/input';

export const QUESTION_TYPES = {
  GOAL: 'subcategory',
};

export function getGoal() {
  const goal = generateSummary()
    .reduce(reduceGoalResponses, [])
    .map(getResponseValue)
    .join(' and ');

  return goal || '';
}

/**
 * Reduces over all steps looking for questions with a type `goal`
 * and includes all of those question responses.
 *
 * @param steps
 * @param step
 * @returns {Array}
 */
function reduceGoalResponses(steps, step) {
  return [
    ...steps,
    ...step.questions.reduce((responses, question) => {
      return question.type === QUESTION_TYPES.GOAL
        ? [...responses, ...question.responses]
        : responses;
    }, []),
  ];
}

/**
 * Different responses have different mechanism for parsing out the value.
 *
 * @param response
 * @returns {string} response value
 */
export function getResponseValue(response) {
  return TYPES_NEEDING_OPTIONS.includes(response.type)
    ? response.valueLabel
    : response.value;
}

/**
 * Generates the data structure used to render a <Summary /> component.
 *
 * @returns {Array}
 */
export function generateSummary() {
  const {
    entities: {steps},
  } = store.getState();
  return Object.keys(steps)
    .map(mapSteps)
    .filter(step => step.questions.length);
}

function mapSteps(stepId) {
  const {
    entities: {steps},
  } = store.getState();
  const step = steps[stepId];

  return {
    ...step,
    questions: step.questions
      .map(mapQuestions)
      .filter(question => question.responses.length),
  };
}

function mapQuestions(questionId) {
  const {
    entities: {questions},
  } = store.getState();
  const question = questions[questionId];

  return {
    ...question,
    responses: question.inputs
      .reduce(reduceOtherInputs, [])
      .reduce(reduceInputs, [])
      .filter(input => input !== null),
  };
}

function reduceInputs(inputResults, inputId) {
  const {
    entities: {inputs},
  } = store.getState();
  const input = inputs[inputId];

  if (!validResponse(input.value)) {
    return inputResults;
  }

  if (Array.isArray(input.value)) {
    return [...inputResults, ...input.value.reduce(reduceValues, [])];
  } else {
    return [...inputResults, mapInput(input, input.value)];
  }

  function reduceValues(valueResults, value) {
    return [...valueResults, mapInput(input, value)];
  }
}

function validResponse(value) {
  if (Array.isArray(value)) {
    return value.length > 0;
  } else {
    return (
      value !== null && value !== undefined && value.toString().trim() !== ''
    );
  }
}

function mapInput(input, value) {
  const option = (input.options || []).find(opt => opt.value === value) || {};

  return {
    ...input,
    value: `${value}`,
    valueLabel: option.label,
    startingBudget: option.starting_budget, // eslint-disable-line camelcase
  };
}

function reduceOtherInputs(inputIds, inputId) {
  const {
    entities: {inputs},
  } = store.getState();
  const input = inputs[inputId];
  const otherInputIds = input.otherInputIds || [];

  return [...inputIds, inputId, ...otherInputIds];
}
